import { useState } from 'react';

const faqs = [
  {
    q: 'A clínica atende por convênio?',
    a: 'Os tratamentos estéticos da MG+ Saúde & Estética são particulares. Trabalhamos com diversas formas de pagamento, incluindo cartões de crédito, débito e PIX, além de parcelamento facilitado.',
  },
  {
    q: 'Como funciona a avaliação inicial?',
    a: 'A avaliação é gratuita e realizada com um de nossos especialistas. Nela, analisamos suas necessidades, histórico de saúde e objetivos para indicar o tratamento mais adequado para você.',
  },
  {
    q: 'Os procedimentos são seguros e indolores?',
    a: 'Sim. Todos os nossos procedimentos são realizados por profissionais certificados, com produtos aprovados pela ANVISA. Utilizamos anestésicos tópicos quando necessário para garantir seu conforto máximo.',
  },
  {
    q: 'Quanto tempo dura cada sessão de tratamento?',
    a: 'O tempo varia conforme o tratamento: limpezas e protocolos faciais levam entre 60 e 90 minutos; procedimentos injetáveis geralmente são realizados em 30 a 60 minutos. Tudo é informado antes da sessão.',
  },
  {
    q: 'Preciso de algum cuidado especial após os procedimentos?',
    a: 'Sim, e nós te orientamos sobre cada um deles! O pós-tratamento é parte fundamental do processo. Nossa equipe fornece um guia completo de cuidados para potencializar e prolongar seus resultados.',
  },
  {
    q: 'Como posso agendar minha consulta?',
    a: 'Você pode agendar pelo formulário de contato neste site, via WhatsApp ou pelo nosso Instagram @mgsaudeeestetica. Respondemos rapidamente e confirmamos seu horário com praticidade.',
  },
];

const FAQ = () => {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-[#FAF7F2] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#C4A45A] text-xs tracking-[0.35em] uppercase font-raleway block mb-3">
            Dúvidas Frequentes
          </span>
          <h2 className="font-cormorant text-4xl md:text-5xl text-[#2C2B29] font-light mb-4">FAQ</h2>
          <p className="font-raleway text-[#8B8680] text-sm">
            Respondemos as principais dúvidas sobre nossa clínica de estética em Santo André.
          </p>
          <div className="w-12 h-px bg-[#C4A45A] mx-auto mt-6" />
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white rounded-xl overflow-hidden border border-[#F0EAE0]"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="font-raleway text-sm font-medium text-[#2C2B29] pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`text-[#C4A45A] text-lg transition-transform duration-300 ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${open === i ? 'max-h-64' : 'max-h-0'}`}
              >
                <p className="font-raleway text-sm text-[#8B8680] leading-relaxed px-6 pb-5">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Schema FAQ */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((f) => ({
              '@type': 'Question',
              name: f.q,
              acceptedAnswer: { '@type': 'Answer', text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
};

export default FAQ;
